






































































































import { Vue, Component, Prop } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import ExternalLink from '@/components/icons/ExternalLink.vue';
import CoinsIcon from '@/components/icons/Coins.vue';
import BackButton from '@/componentsV2/molecules/BackButton/BackButton.vue';
import CustomerImportEmailPreview from '@/componentsV2/templates/CustomerImportEmailPreview/CustomerImportEmailPreview.vue';

import { CustomerImportFormData } from '../CustomerImportModal.vue';
import CustomerImportPreviewEmail from '@/views/MarketingCenter/CustomerImport/CustomerImportPreviewEmail.vue';
import InfoIcon from '@/components/icons/Info.vue';

@Component<OfferCreationStep2>({
  components: {
    FilledButton,
    GhostButton,
    ExternalLink,
    CoinsIcon,
    BackButton,
    CustomerImportEmailPreview,
    CustomerImportPreviewEmail,
    InfoIcon
  },
  computed: {
    totalCoins() {
      return this.coinsPerCustomer * this.eligibleCustomersAmount;
    }
  }
})
export default class OfferCreationStep2 extends Vue {
  @Prop() customerImportFormData!: CustomerImportFormData;
  @Prop(Number) coinsPerCustomer!: number;
  @Prop(Number) eligibleCustomersAmount!: number;
  @Prop({ default: false }) loading?: boolean;

  baseFontEmail = '6.7px';
  visibledPreview = false;

  get currencySymbol() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get customerImportV2() {
    return this.flags.includes('customer-import-v2');
  }

  handlePreviewEmail() {
    this.$analytics({
      eventCategory: `Import Customers Modals | Review and send campaign modal (Step 2)`,
      eventAction: 'click',
      eventLabel: `Clicked on the "Preview email " button`
    });

    const emailPreviewUrl = `/customer-import/preview-email?coinsPerCustomer=${
      this.coinsPerCustomer
    }`;
    if (this.$mobileCheck()) {
      this.visibledPreview = true;
    } else {
      window.open(emailPreviewUrl, '_blank');
    }
  }

  handleSubmit() {
    const { clickedCTA } = this.$route.query;

    this.$analytics({
      eventCategory: `Import Customers Modals | Review and send campaign modal (Step 2)`,
      eventAction: 'click',
      eventLabel: `Clicked on the "Send campaign" button${
        clickedCTA ? ' when user is from banner' : ''
      }`
    });

    this.$emit('submit');
  }

  handleBack() {
    this.$analytics({
      eventCategory: `Import Customers Modals | Review and send campaign modal (Step 2)`,
      eventAction: 'click',
      eventLabel: `Clicked on the "Back" button`
    });

    this.$emit('back');
  }
}
